import { Injectable } from '@angular/core'
import { TaskList } from '@awork/features/task/models/task-list.model'
import { EntitySignalStore } from '@awork/core/state/signal-store/entitySignalStore'

@Injectable({ providedIn: 'root' })
export class TaskListStore extends EntitySignalStore<TaskList> {
  constructor() {
    super({
      name: 'taskList',
      entityConstructor: taskList => new TaskList(taskList),
      nullableProps: ['order']
    })
  }
}
